/**
 *  {
      "item_ref": "0010",
      "event_code": "EARN",
      "item_type": "privilege",
      "target": "instant",
      "coupons": [
        {
          "type": "multiplier",
          "qty": 1,
          "logic": "[earn_amount] * 2",
          "coupon_id": "coupon-38f1fe5bb5982c15e0c6ead8"
        }
      ],
      "tier_id": "tier-6003e816c2869603433f5c72"
    },
 */
class Privilege {
  constructor({ condition, coupon }) {
    this.condition = condition;
    this.coupon = coupon;
  }

  getPayloadforPayment(pricebeforeDiscount, tierId) {
    return {
      item_ref: "PRIV001",
      event_code: "EARN",
      item_type: "privilege",
      target: "instant",
      coupons: [this.coupon.getPayloadData(pricebeforeDiscount)],
      tier_id: tierId,
    };
  }
}

export default Privilege;
